module.exports = {"pathContext":{"name":"LabResultConnection","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"edges","type":{"kind":"LIST","name":null,"ofType":{"kind":"OBJECT","name":"LabResultEdge","ofType":null}}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"pageInfo","type":{"kind":"NON_NULL","name":null,"ofType":{"kind":"OBJECT","name":"PageInfo","ofType":null}}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/object-lab-result-connection.json
// module id = 1821
// module chunks = 59245617098652